module.exports = __webpack_public_path__ + "img/Pic_Services-2.b7acf001.jpg";